import { VideoMediaCenterMenu } from './video-media-center-menu'

const { videojs } = global
const MenuButton = videojs.getComponent('MenuButton')

/**
 * @class
 * @extends MenuButton
 */
export class VideoMediaCenterButton extends MenuButton {
  /**
   * Button to toggle Video Media Center
   * @param {Player|Object} player
   */
  constructor (player) {
    super(player)
    this.addClass('vjs-video-media-center')
  }

  /**
   * return list of css classes that will be applied to container
   * @returns {string}
   */
  // eslint-disable-next-line class-methods-use-this
  buildCSSClass () {
    return 'vjs-subs-caps-button vjs-menu-button vjs-menu-button-popup vjs-button'
  }

  /**
   * create custom menu item
   * @returns {VideoMediaCenterMenu}
   */
  createMenu () {
    return new VideoMediaCenterMenu(this.player(), { menuButton: this })
  }
}

export default VideoMediaCenterButton
